import PropTypes from "prop-types";
import React from "react";
import { Navigate } from "react-router-dom";
const FaqRedirect = ({ user }) => {
    if(!user) {
        // Default to public investors FAQ if no user
        return <Navigate to="/faq/public/investors" replace />;
    }

    // For logged-in users, redirect to dashboard FAQ routes based on role
    if(user.role === "investor" || user.role === "entrepreneur") {
        return <Navigate to={`/dashboard/faq/${user.role}s`} replace />;
    }

    // Default fallback for admin role
    return <Navigate to="/FAQ-management" replace />;
};

FaqRedirect.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string,
    }),
};

export default FaqRedirect;
